import { createContext, Dispatch, ReactNode, SetStateAction } from 'react';
import {
  NOTIFICATION_GROUP,
  NOTIFICATION_STATUS,
  NotificationType,
  NotificationGroup,
  NotificationsStatus,
  NOTIFICATIONS_NUMBER_OF_PLACEHOLDERS,
  NotificationBy,
  NOTIFICATION_BY,
} from 'models/Notification';
import utils from 'utils';

export type NotificationsCountType = {
  all: number;
  unread: number;
};

type NotificationsContextProps = {
  fetchingNotifications: boolean;
  numberOfPlaceholders: number;
  notificationsCount: NotificationsCountType;
  notifications: Array<NotificationType>;
  isDrawerOpen: boolean;
  notificationStatus: NotificationsStatus;
  notificationGroup: NotificationGroup;
  notificationBy: NotificationBy;
  setIsDrawerOpen: (value: boolean) => void;
  deleteNotification: (notification: NotificationType) => void;
  readAllNotifications: () => void;
  onNotificationsScroll: () => void;
  setNotificationStatus: Dispatch<SetStateAction<NotificationsStatus>>;
  setNotificationGroup: Dispatch<SetStateAction<NotificationGroup>>;
  setNotificationBy: Dispatch<SetStateAction<NotificationBy>>;
  redirectionPath: (notification: NotificationType) => string;
  getDynamicRedirectionPath: (
    notification: NotificationType,
  ) => () => Promise<string>;
  onDeleteNotification: (notification: NotificationType) => void;
  onReadNotification: (
    notificationId: string,
    keepDrawerOpen?: boolean,
  ) => void;
  onUnreadNotification: (
    notificationId: string,
    keepDrawerOpen?: boolean,
  ) => void;
  getContent: (notification: NotificationType) => string;
  getCtaText: (notification: NotificationType) => string;
  getCtaPrimary: (notification: NotificationType) => string;
  getCtaSecondary: (notification: NotificationType) => string;
  getCtaIcon: (notification: NotificationType) => ReactNode;
  getIsLoadingNotification: (notificationId: string) => boolean;
};

export default createContext<Partial<NotificationsContextProps>>({
  fetchingNotifications: false,
  isDrawerOpen: false,
  numberOfPlaceholders:
    NOTIFICATIONS_NUMBER_OF_PLACEHOLDERS.INITIAL_LOADING_COUNT,
  notifications: [],
  notificationStatus: NOTIFICATION_STATUS.ALL,
  notificationGroup: NOTIFICATION_GROUP.FYA,
  notificationBy: NOTIFICATION_BY.FOR_YOU,
  notificationsCount: null,
  setNotificationStatus: utils.noop,
  setNotificationGroup: utils.noop,
  setNotificationBy: utils.noop,
  setIsDrawerOpen: utils.noop,
  deleteNotification: utils.noop,
  readAllNotifications: utils.noop,
  onNotificationsScroll: utils.noop,
  redirectionPath: utils.noop,
  getDynamicRedirectionPath: utils.noop,
  onDeleteNotification: utils.noop,
  onReadNotification: utils.noop,
  getContent: utils.noop,
  getCtaText: utils.noop,
  getCtaPrimary: utils.noop,
  getCtaSecondary: utils.noop,
  getCtaIcon: utils.noop,
  getIsLoadingNotification: utils.noop,
});
